import Card, { CardGrid } from "../components/Card";
import StatTable from "../components/StatTable";
import StatsGate from "../components/StatsGate";
import { TabProps, Tenants } from "../types";
import { useStats } from "../useStats";

export default function TenantsTab({ query, reloadKey, gameId }: TabProps) {
  const state = useStats<Tenants>("/tenants", query, reloadKey);
  // New fans are not scoped to a single game, so say so once a game id filters everything else.
  const newFansHeader = gameId ? "New fans (all games)" : "New fans";
  return (
    <StatsGate state={state}>
      {(data) => (
        <CardGrid>
          <Card title="Tenants side by side" wide>
            <StatTable
              rows={data.tenants} getRowId={(r) => r.tenant}
              columns={[
                { field: "name", headerName: "Tenant", flex: 1.5 },
                { field: "activeUsers", headerName: "Active fans", type: "number", flex: 1 },
                { field: "newUsers", headerName: newFansHeader, type: "number", flex: 1 },
                { field: "messages", headerName: "Messages", type: "number", flex: 1 },
                { field: "reactions", headerName: "Reactions", type: "number", flex: 1 },
                { field: "watchParties", headerName: "Parties", type: "number", flex: 1 },
                { field: "moments", headerName: "Fan clips", type: "number", flex: 1 },
                { field: "downloadsCompleted", headerName: "Downloads", type: "number", flex: 1 },
                { field: "reports", headerName: "Reports", type: "number", flex: 1 },
              ]}
            />
          </Card>
        </CardGrid>
      )}
    </StatsGate>
  );
}
